// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView  from "iview"
import axios from 'axios'
import 'iview/dist/styles/iview.css'
import http from '@/utils/http/index.js'
import VueWechatTitle from 'vue-wechat-title';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(VueWechatTitle)

Vue.use(iView)
Vue.use(ElementUI);
Vue.prototype.$axios = axios
Vue.prototype.$http = http

Vue.config.productionTip = false





Vue.prototype.$remove =function(data,obj,key){
				data.splice(this.$DataIndex(data,obj,key),1);
			}
Vue.prototype.$DataIndex=function(data,obj,key){
				for(let i=0;i<data.length;i++){
					if(data[i][key]==obj[key]){
						return i;
					}
				}
				return -1;
			}
Vue.prototype.$DataObject=function(data,id,key){
				for(let i=0;i<data.length;i++){
					if(data[i][key]==id){
						return data[i];
					}
				}
				return -1;
			}
Vue.prototype.$Replace=function(data,obj,key){
				data.splice(this.$DataIndex(data,obj,key),1,obj);
			}
Vue.prototype.$array_remove_repeat=function(a) { // 去重
    var r = [];
    for(var i = 0; i < a.length; i ++) {
        var flag = true;
        var temp = a[i];
        for(var j = 0; j < r.length; j ++) {
            if(temp === r[j]) {
                flag = false;
                break;
            }
        }
        if(flag) {
            r.push(temp);
        }
    }
    return r;
}


Vue.prototype.$array_difference=function(a, b) { // 差集 a - b
    //clone = a
    var clone = a.slice(0);
    for(var i = 0; i < b.length; i ++) {
        var temp = b[i];
        for(var j = 0; j < clone.length; j ++) {
            if(temp === clone[j]) {
                //remove clone[j]
                clone.splice(j,1);
            }
        }
    }
    return this.$array_remove_repeat(clone);
}

Vue.prototype.$array_union=function(a, b) { // 并集
    return this.$array_remove_repeat(a.concat(b));
}
Vue.prototype.$filterDate=function(table,total,page,size){
				let temp=[];
				for(let i=(page-1)*size,j=0;i<page*size;i++,j++){
					if(i>=total){
						break;
					}
					temp[j]=table[i];
				}
				return temp;
			}
Date.prototype.format = function(format)
{
	 var o = {
	 "M+" : this.getMonth()+1, //month
	 "d+" : this.getDate(),    //day
	 "h+" : this.getHours(),   //hour
	 "m+" : this.getMinutes(), //minute
	 "s+" : this.getSeconds(), //second
	 "q+" : Math.floor((this.getMonth()+3)/3),  //quarter
	 "S" : this.getMilliseconds() //millisecond
	 }
	 if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
	 (this.getFullYear()+"").substr(4 - RegExp.$1.length));
	 for(var k in o)if(new RegExp("("+ k +")").test(format))
	 format = format.replace(RegExp.$1,
	 RegExp.$1.length==1 ? o[k] :
	 ("00"+ o[k]).substr((""+ o[k]).length));
	 return format;
}


Vue.prototype.isWxBrowser=function(){
	var ua = window.navigator.userAgent.toLowerCase();
	return ua.match(/MicroMessenger/i) == 'micromessenger';
}


String.prototype.replaceAll = function(s1,s2){
　　return this.replace(new RegExp(s1,"gm"),s2);
}





/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  created:function(){
  	// localStorage.ServerUrl="http://192.168.10.13:8086/BackStage";
  	localStorage.ServerUrl="https://m.url1.cn/BackStage";
  }
})



// WEBPACK FOOTER //
// ./src/main.js